<template>
  <div>
    <full-page ref="fullpage" :options="options" id="fullpage">
      <div v-for="component in componentNames" :key="component" class="section">
        <component :is="component" />
      </div>
    </full-page>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

import Home from '@/views/Home.vue';
import Vision from '@/views/Vision.vue';
import Products from '@/views/Products.vue';
import Team from '@/views/Team.vue';
import Values from '@/views/Values.vue';
import Careers from '@/views/Careers.vue';

export default {
  components: {
    Home,
    Vision,
    Products,
    Team,
    Values,
    Careers,
  },
  created() {
    this.$root.$on('menu-click', name => {
      this.silentScroll(name);
      this.closeMenu();
    });
  },
  mounted() {
    const silentTo = this.$route.params.silentTo;
    if (silentTo) {
      this.silentScroll(silentTo);
      this.closeMenu();
    }
  },
  beforeDestroy() {
    this.$root.$off('menu-click');
  },
  data() {
    return {
      componentNames: ['home', 'vision', 'products', 'team', 'values', 'careers'],
      options: {
        licenseKey: 'FE82D54E-4D0C4D2A-BF8A31F7-F1977EB3',
        verticalCentered: false,
        anchors: ['home', 'vision', 'products', 'team', 'values', 'careers'],
        onLeave: this.handleOnLeave,
      },
    };
  },
  methods: {
    ...mapMutations(['closeMenu', 'changeSectionName']),
    handleOnLeave(from, to) {
      if (from.anchor === to.anchor) return;
      this.changeSectionName(to.anchor);
    },
    silentScroll(name) {
      this.$refs.fullpage.api.setScrollingSpeed(0);
      this.$refs.fullpage.api.moveTo(name);
      this.$refs.fullpage.api.setScrollingSpeed(600);
    },
  },
};
</script>

<style lang="scss" scoped></style>
